
import { Swarm } from '@lbs/swarm-client';

import { createBetCashierSwarmQuery, getBetMaxStakeCashierSwarmQuery, getHotKeysSwarmQuery } from "src/common/swarm/queries/bet";
import { ISwarmBetMaxStakeTerminalResponse, ISwarmCreateBetCashierResponse, ISwarmHotKeyGameDetailsResponse, ISwarmHotKeyModel } from "src/common/swarm/models/response";
import { BetTypeEnum } from "src/constants/enums/betType";
import { ISwarmCreateBetCashierRequest } from "src/common/swarm/models/request";
import { getHotKeyGameDetailsSwarmQuery } from 'src/common/swarm/queries/events';

class CashierSwarmActions {

    static getHotKeys = async () => {
        const { data: { data: result } } = await Swarm
            .getInstance()
            .getData(...getHotKeysSwarmQuery());

        return (result?.data || []) as ISwarmHotKeyModel[];
    }

    static getHotKeyGameDetails = async (gameNumber: number, hotKeyModel: ISwarmHotKeyModel) => {
        const { data: { data: result } } = await Swarm.getInstance().getData(getHotKeyGameDetailsSwarmQuery(gameNumber, hotKeyModel));

        return result?.data as ISwarmHotKeyGameDetailsResponse;
    }

    static requestMaxStake = async (eventIds: number[], betType: BetTypeEnum, systemMinCount?: number) => {
        const { data: { data: result } } = await Swarm
            .getInstance()
            .getData(...getBetMaxStakeCashierSwarmQuery(eventIds, betType, systemMinCount));

        return (result.data as ISwarmBetMaxStakeTerminalResponse).MaxStake;
    };

    static placeBet = async (request: ISwarmCreateBetCashierRequest) => {
        const { data: { data: result } } = await Swarm
            .getInstance()
            .getData(...createBetCashierSwarmQuery(request));

        if (result.text_code !== '0') throw result;

        return result.data as ISwarmCreateBetCashierResponse;
    }
};

export default CashierSwarmActions;
